import type { AccountType } from '@/types/Models/Account'
import type { StatusType } from '@/types/Models/Assignment'
import { CUSTOMER, STAFF } from '@/const/AccountTypes'
import {
  CANCELLED,
  COMPLETE,
  LABELS_CREATING,
  LABELS_RELEASED,
  OPTIMISING,
  OPEN,
  PENDING,
  REPORT_ACCEPTED,
  REPORT_DENIED,
  REPORT_RELEASED,
  VALIDATING,
  VALIDATION_COMPLETE,
} from '@/const/AssignmentStatuses'

type ActionColorMap = {
  [key in AccountType]: {
    [key in StatusType]: string
  }
}
export const ActionColor: ActionColorMap = {
  [STAFF]: {
    [OPEN]: 'button-blue', // #3498db
    [PENDING]: 'button-yellow', // #f1c40f
    [VALIDATING]: 'button-light-gray', // #bdc3c7
    [VALIDATION_COMPLETE]: 'button-green', // #2ecc71
    [OPTIMISING]: 'button-purple', // #9b59b6
    [REPORT_RELEASED]: 'button-teal', // #1abc9c
    [REPORT_ACCEPTED]: 'button-dark-green', // #27ae60
    [REPORT_DENIED]: 'button-red', // #e74c3c
    [LABELS_CREATING]: 'button-gray', // #95a5a6
    [LABELS_RELEASED]: 'button-green-teal', // #16a085
    [CANCELLED]: 'button-dark-red', // #c0392b
    [COMPLETE]: 'button-green', // #2ecc71
  },
  [CUSTOMER]: {
    [OPEN]: 'button-blue',
    [PENDING]: 'button-yellow',
    [VALIDATING]: 'button-light-gray',
    [VALIDATION_COMPLETE]: 'button-green',
    [OPTIMISING]: 'button-purple',
    [REPORT_RELEASED]: 'button-teal',
    [REPORT_ACCEPTED]: 'button-dark-green',
    [REPORT_DENIED]: 'button-red',
    [LABELS_CREATING]: 'button-gray',
    [LABELS_RELEASED]: 'button-green-teal',
    [CANCELLED]: 'button-dark-red',
    [COMPLETE]: 'button-green',
  },
}
